export default __webpack_public_path__ + "static/media/selfTestBg.9575dcc5.png";